import { render } from "./AddFollower.vue?vue&type=template&id=0fff6b34"
import script from "./AddFollower.vue?vue&type=script&lang=js"
export * from "./AddFollower.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__